var React = require('react');
var Router = require('react-router').Router
var Route = require('react-router').Route
var IndexRoute = require('react-router').IndexRoute;
var Redirect = require('react-router').Redirect;
var applyRouterMiddleware = require('react-router').applyRouterMiddleware;
var useScroll = require('react-router-scroll').useScroll;
var Main = require('./main/containers/main.jsx');
var Home = require('./home/containers/home.jsx');
var App = require('./app/containers/app.jsx');
var Register = require('./register/containers/register.jsx');
var Login = require('./login/containers/login.jsx');
var PasswordResetRequest = require('./password-reset/containers/password-reset-request.jsx');
var PasswordReset = require('./password-reset/containers/password-reset.jsx');
var Privacy = require('./privacy/components/privacy.jsx');
var Terms = require('./terms/components/terms.jsx');
var ContactSuccess = require('./contact-success/components/contact-success.jsx');
var Symptom = require('./education/containers/symptom.jsx');
var BodyPart = require('./education/containers/bodypart.jsx');
var Education = require('./education/containers/education.jsx');
var Disease = require('./education/containers/disease.jsx');
var Qol = require('./education/containers/qol.jsx');
var NotFound = require('./not-found/components/not-found.jsx');
var Condition = require('./conditions/containers/condition.jsx');
var Conditions = require('./conditions/containers/conditions.jsx');
var Messages = require('./message-center/containers/messages.jsx');
var Message = require('./message-center/containers/message.jsx');
var MessageCreate = require('./message-center/containers/message-create.jsx');
var MessageEdit = require('./message-center/containers/message-edit.jsx');
var Profile = require('./profile/containers/profile.jsx');
var checkAuth = require('./auth/components/checkAuth.jsx');
var requireAuth = require('./auth/components/requireAuth.jsx');
var enableFacebookLikeModal = require('./components/enableFacebookLikeModal.jsx');
var Faqs = require('./faqs/containers/faqs.jsx');
var checkSurveys = require('./survey/components/checkSurveys.jsx');
var loadSurveys = require('./survey/components/loadSurveys.jsx');
var Survey = require('./survey/containers/survey.jsx');
var DashboardWrapper = require('./dashboard/components/dashboardWrapper.jsx');
var DashboardContainer = require('./dashboard/components/dashboardContainer.jsx');
var FindASpecialistContainer = require('./find-a-specialist/containers/find-a-specialist.jsx');
var Post = require('./posts/containers/post.jsx');
var PostList = require('./posts/containers/postList.jsx');
var About = require('./about/components/about.jsx');
var Partners = require('./partners/components/partners.jsx');
var Clinical = require('./clinical/containers/clinical.jsx');
var Trials = require('./trials/containers/trialsList.jsx');
var checkSubdomain = require('./subdomain/checkSubdomain.jsx');
var PracticeLandingPage = require('./practice/containers/practiceLandingPage.jsx');
var PracticeConfirmationPage = require('./practice/containers/practiceConfirmationPage.jsx');

// https://github.com/rafrex/react-router-hash-link/tree/react-router-v2/3
function hashLinkScroll() {
  const { hash } = window.location;
  if (hash !== '') {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
}

function routes(history) {
  return (
    <Router history={history} onUpdate={hashLinkScroll} render={applyRouterMiddleware(useScroll())}>
      <Route path="/sign-up" component={PracticeLandingPage} />
      <Route path="/confirmation-page" component={checkAuth(PracticeConfirmationPage)} />
      <Route path="/" component={checkAuth(enableFacebookLikeModal(checkSubdomain(Main)))}>
        <IndexRoute component={Home} />
        <Route path="app" component={App} />
        <Route path="login" component={Login} />
        <Route path="register" component={Register} />
        <Route path="password-reset" component={PasswordResetRequest} />
        <Route path="password-reset/:token" component={PasswordReset} />
        <Route path="education" component={Education} />
        <Route path="education/symptoms/:name" component={Symptom} />
        <Route path="education/bodyparts/:name" component={BodyPart} />
        <Route path="education/diseases/:name" component={Disease} />
        <Route path="education/quality-of-life/:name" component={Qol} />
        <Route path="privacy" component={Privacy} />
        <Route path="terms" component={Terms} />
        <Route path="help" component={Faqs} />
        <Redirect from="contact" to="help" />
        <Route path="contact/success" component={ContactSuccess} />
        <Route path="conditions" component={Conditions} />
        <Route path="conditions/:name" component={Condition} />
        <Route path="admin/message-center" component={requireAuth(Messages)} />
        <Route path="admin/message-center/create" component={requireAuth(MessageCreate)} />
        <Route path="admin/message-center/:id" component={requireAuth(Message)} />
        <Route path="admin/message-center/:id/copy" component={requireAuth(MessageCreate)} />
        <Route path="admin/message-center/:id/edit" component={requireAuth(MessageEdit)} />
        <Route path="profile" component={requireAuth(Profile)} />
        <Redirect from="surveys/:surveyType" to="dashboard/surveys/:surveyType" />
        <Redirect from="dashboard" to="dashboard/mygi" />
        <Route path="dashboard" component={requireAuth(DashboardWrapper)}>
            <IndexRoute component={DashboardContainer} />
            <Route path="surveys/:surveyType" component={loadSurveys(checkSurveys(Survey))} />
            <Route path=":dashboardType" component={DashboardContainer} />
        </Route>
        <Route path="find-a-specialist" component={FindASpecialistContainer} />
        <Redirect from="blog" to="blog/all" />
        <Route path="blog(/:categorySlug)" component={PostList} />
        <Route path="blog/:categorySlug/page/:pageNum" component={PostList} />
        <Route path="blog/:categorySlug/:slug" component={Post} />
        <Route path="about" component={About} />
        <Route path="partners" component={Partners} />
        <Route path="clinical-use" component={Clinical} />
        <Route path="trials(/:page)" component={Trials} />
        <Route path="*" component={NotFound}/>
      </Route>
    </Router>
  );
};

module.exports = routes;



// WEBPACK FOOTER //
// ./src/common/routes/routes.jsx